import { render } from "./PostLists.vue?vue&type=template&id=499c4e24"
import script from "./PostLists.vue?vue&type=script&lang=js"
export * from "./PostLists.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__